const RESET_PASSWORD_PATH = '/passwort-zuruecksetzen'

export function isResetPasswordPath(pathname: string): boolean {
  return pathname === RESET_PASSWORD_PATH || pathname === `${RESET_PASSWORD_PATH}/`
}

export function takeResetTokenFromUrl(): string | null {
  const url = new URL(window.location.href)
  const token = url.searchParams.get('token')
  if (url.searchParams.has('token')) {
    url.searchParams.delete('token')
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`)
  }
  return token && token.trim() ? token : null
}
